<template>
  <div>
    <div class="com-header">
      <v-com-header></v-com-header>
    </div>
    <div class="com-content">
      <router-view/>
    </div>
    <div class="com-footer">
      <v-com-footer></v-com-footer>
    </div>
  </div>
</template>

<script>
import ComHeader from "./ComHeader";
import ComFooter from "./ComFooter";
export default {
  components: {
    "v-com-header": ComHeader,
    "v-com-footer": ComFooter
  }
};
</script>
